import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import OurTeamPage from './pages/OurTeamPage';
import ContactPage from './pages/ContactPage';
import StudiosPage from './pages/StudiosPage';
import StudioDetailPage from './pages/StudioDetailPage';
import SegmentsPage from './pages/SegmentsPage';
import ServicesPage from './pages/ServicesPage';
import PartnershipPage from './pages/PartnershipPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import CafeConnectionsPage from './pages/CafeConnectionsPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboardHome from './pages/admin/AdminDashboardHome';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminBlogEditor from './pages/admin/AdminBlogEditor';
import AdminInstagram from './pages/admin/AdminInstagram';
import AdminCatalogues from './pages/admin/AdminCatalogues';
import AdminSettings from './pages/admin/AdminSettings';
import ScrollToTop from './components/ScrollToTop';
import './App.css';


function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/our-team" element={<OurTeamPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/studios" element={<StudiosPage />} />
          <Route path="/studio/:studioName" element={<StudioDetailPage />} />
          <Route path="/segments" element={<SegmentsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/partnership" element={<PartnershipPage />} />
          <Route path="/cafe-connections" element={<CafeConnectionsPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboardHome />} />
          <Route path="/admin/blogs" element={<AdminBlogs />} />
          <Route path="/admin/blogs/new" element={<AdminBlogEditor />} />
          <Route path="/admin/blogs/edit/:id" element={<AdminBlogEditor />} />
          <Route path="/admin/instagram" element={<AdminInstagram />} />
          <Route path="/admin/catalogues" element={<AdminCatalogues />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          {/* Redirect old admin route to new dashboard */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
		
		
<a
  href="https://wa.me/917290085871"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-float"
  style={{
    position: "fixed",
    right: "20px",
    top: "80%",
    transform: "translateY(-50%)",
    width: "65px",
    height: "65px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
    zIndex: "999999",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  }}
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
    style={{
      width: "38px",
      height: "38px",
    }}
  />
</a>		
		
		
		
      </div>
	  
	  
    </HelmetProvider>
  );
}



export default App;
